import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    constructor() {
        super(...arguments);
        this.title = '课程管理后台';
    }
};
tslib_1.__decorate([
    Prop({ required: true })
], default_1.prototype, "collapse", void 0);
default_1 = tslib_1.__decorate([
    Component({
        name: 'SidebarLogo',
    })
], default_1);
export default default_1;
